import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { environment } from 'environments/environment';
import { catchError, Observable, tap, throwError } from 'rxjs';

export const apiInterceptor = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    if (request.url.startsWith('hippo')) {
        const requestUrl = request.url.replace('hippo/', environment.apiURL);
        request = request.clone({ url: requestUrl, withCredentials: true });
    } else {
        request = request.clone({ url: request.url });
    }

    return next(request).pipe(
        tap(evt => {
            // TODO Handle Session Timeout
        }),
        catchError(error => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // authService.signOut();
                // location.reload();
            }

            return throwError(error);
        })
    );
};
